module.exports = __webpack_public_path__ + "img/location-request.c12b3c63.png";